import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useThemeStore = create()(persist((set) => ({
    isDark: false,
    toggle: () => set((s) => ({ isDark: !s.isDark })),
    setDark: (v) => set({ isDark: v }),
}), { name: 'gxl-theme' }));
//# sourceMappingURL=theme.store.js.map